var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7201 2.4H5.28011C4.22123 2.4 3.36011 3.26112 3.36011 4.32V19.68C3.36011 20.7389 4.22123 21.6 5.28011 21.6H18.7201C19.779 21.6 20.6401 20.7389 20.6401 19.68V4.32C20.6401 3.26112 19.779 2.4 18.7201 2.4ZM5.28011 4.32V19.68H18.7211L18.7201 4.32H5.28011Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12011 15.84H7.20011V17.76H9.12011V15.84ZM12.9601 12H11.0401V13.92H12.9601V12ZM16.8001 6.24H7.20011V10.08H16.8001V6.24ZM12.9601 15.84H11.0401V17.76H12.9601V15.84ZM16.8001 12H14.8801V17.76H16.8001V12Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20011 12H9.12011V13.92H7.20011V12Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "483b64378e514f91ab497038d42ebade.svg";
export { ForwardRef as ReactComponent };